import { isEqual } from 'lodash';

type ArchiveDatesProps = {
  dates: Array<string>;
  selectedYear: string;
  onClickSelectYear: (year: string) => void;
};

export function ArchiveDates(props: ArchiveDatesProps) {
  const { dates, selectedYear, onClickSelectYear } = props;

  const archiveDatesContent = dates.map((date) => {
    return (
      <button
        className={`font-MuseoSans500 text-left text-subtitle font-bold ${
          isEqual(selectedYear, date) ? 'text-primaryBlue' : 'text-black'
        } hover:text-primaryBlue`}
        key={date}
        onClick={() => onClickSelectYear(date)}
      >
        {date}
      </button>
    );
  });

  return (
    <div className="flex-col pl-4 mb-10 hidden lg:flex">
      <p className="font-MuseoSans500 mb-2 font-bold text-subtitle">ARCHIVE</p>
      <div className="flex flex-col space-y-2">{archiveDatesContent}</div>
    </div>
  );
}

export default ArchiveDates;
